/* ============================================================
   BOOKSCART ONLINE — Theme JS
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Mobile nav + mega toggles ---------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('.menu-toggle');
    if (toggle) {
      var nav = document.querySelector('.nav');
      if (nav) nav.classList.toggle('is-open');
      return;
    }
    // On mobile, tapping a parent nav link opens its mega panel
    var parentLink = e.target.closest('.nav__link[aria-haspopup]');
    if (parentLink && window.matchMedia('(max-width: 990px)').matches) {
      e.preventDefault();
      var item = parentLink.closest('.nav__item');
      if (item) item.classList.toggle('is-open');
    }
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var wrap = btn.closest('.quantity');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    val += btn.dataset.qty === 'up' ? 1 : -1;
    if (val < 1) val = 1;
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Accordions ---------- */
  document.addEventListener('click', function (e) {
    var head = e.target.closest('.accordion__head');
    if (!head) return;
    var body = head.nextElementSibling;
    var open = head.getAttribute('aria-expanded') === 'true';
    head.setAttribute('aria-expanded', String(!open));
    if (body) body.hidden = open;
  });

  /* ---------- Product gallery thumbnails ---------- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('.product__thumb, .pdp__thumb');
    if (!thumb) return;
    var main = document.querySelector('.product__main-image img, #ProductMainImage');
    var full = thumb.getAttribute('data-full');
    if (main && full) main.src = full;
    var group = thumb.classList.contains('pdp__thumb') ? '.pdp__thumb' : '.product__thumb';
    document.querySelectorAll(group).forEach(function (t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  });

  /* ---------- Cart drawer ---------- */
  var drawer = document.getElementById('CartDrawer');
  function openDrawer() { if (drawer) { drawer.classList.add('is-open'); refreshDrawer(); } }
  function closeDrawer() { if (drawer) drawer.classList.remove('is-open'); }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-cart]') && drawer) { e.preventDefault(); openDrawer(); }
    if (e.target.closest('[data-close-cart]') || e.target.classList.contains('drawer__overlay')) closeDrawer();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  function refreshDrawer() {
    var body = drawer && drawer.querySelector('.drawer__body');
    if (!body) return;
    fetch('/?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('.drawer__body');
        var foot = tmp.querySelector('.drawer__foot');
        if (fresh) body.innerHTML = fresh.innerHTML;
        var curFoot = drawer.querySelector('.drawer__foot');
        if (fresh && foot && curFoot) curFoot.innerHTML = foot.innerHTML;
      })
      .catch(function () {});
  }

  /* ---------- AJAX add-to-cart ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var original = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = 'Adding\u2026'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
      body: new URLSearchParams(new FormData(form)).toString()
    })
      .then(function (r) { return r.json(); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        if (btn) { btn.innerHTML = 'Added \u2713'; }
        if (drawer) openDrawer();
        setTimeout(function () { if (btn) { btn.disabled = false; btn.innerHTML = original; } }, 1400);
      })
      .catch(function () { if (btn) { btn.disabled = false; btn.innerHTML = original; } });
  });

  function updateCartCount(count) {
    document.querySelectorAll('.cart-count').forEach(function (el) {
      el.textContent = count; el.hidden = count === 0;
    });
  }

  /* ---------- Wishlist (localStorage) ---------- */
  var WKEY = 'bookscart_wishlist';
  function getWishlist() { try { return JSON.parse(localStorage.getItem(WKEY)) || []; } catch (e) { return []; } }
  function setWishlist(a) { localStorage.setItem(WKEY, JSON.stringify(a)); }
  function markWishlist() {
    var list = getWishlist();
    document.querySelectorAll('[data-wishlist]').forEach(function (b) {
      b.classList.toggle('is-active', list.indexOf(b.dataset.wishlist) !== -1);
    });
    var counter = document.querySelector('[data-wishlist-count]');
    if (counter) counter.textContent = list.length;
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wishlist]');
    if (!b) return;
    e.preventDefault();
    var id = b.dataset.wishlist, list = getWishlist(), i = list.indexOf(id);
    if (i === -1) list.push(id); else list.splice(i, 1);
    setWishlist(list); markWishlist();
  });

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window) || !els.length) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Announcement rotator ---------- */
  function initAnnouncement() {
    var track = document.querySelector('[data-announcement-rotate]');
    if (!track) return;
    var items = track.querySelectorAll('.announcement__item');
    if (items.length < 2) return;
    var i = 0;
    items.forEach(function (it, idx) { it.style.display = idx === 0 ? '' : 'none'; });
    setInterval(function () {
      items[i].style.display = 'none';
      i = (i + 1) % items.length;
      items[i].style.display = '';
    }, 4000);
  }

  /* ---------- Premium hero tilt (respects reduced motion) ---------- */
  function initHeroTilt() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var books = document.querySelector('.hero__books');
    var hero = document.querySelector('.hero');
    if (!books || !hero) return;
    hero.addEventListener('mousemove', function (e) {
      var r = hero.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5;
      var y = (e.clientY - r.top) / r.height - 0.5;
      books.style.transform = 'rotateY(' + (x * 10) + 'deg) rotateX(' + (-y * 8) + 'deg)';
    });
    hero.addEventListener('mouseleave', function () { books.style.transform = ''; });
  }

  /* ---------- Sticky header shadow on scroll ---------- */
  function initHeaderScroll() {
    var header = document.querySelector('.header');
    if (!header) return;
    var onScroll = function () {
      header.style.boxShadow = window.scrollY > 10 ? '0 6px 20px rgba(15,23,42,.08)' : '';
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- 3D tilt on cards ---------- */
  function initTilt() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.matchMedia('(hover: none)').matches) return;
    document.querySelectorAll('[data-tilt]').forEach(function (el) {
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        el.style.transform = 'perspective(800px) rotateY(' + (px * 10) + 'deg) rotateX(' + (-py * 10) + 'deg) translateY(-6px)';
      });
      el.addEventListener('mouseleave', function () { el.style.transform = ''; });
    });
    // Profession spotlight follow
    document.querySelectorAll('.profession').forEach(function (el) {
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        el.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100) + '%');
        el.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100) + '%');
      });
    });
  }

  /* ---------- Magnetic buttons ---------- */
  function initMagnetic() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.matchMedia('(hover: none)').matches) return;
    document.querySelectorAll('[data-magnetic]').forEach(function (el) {
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        el.style.transform = 'translate(' + ((e.clientX - r.left - r.width / 2) * 0.3) + 'px,' + ((e.clientY - r.top - r.height / 2) * 0.4) + 'px)';
      });
      el.addEventListener('mouseleave', function () { el.style.transform = ''; });
    });
  }

  /* ---------- Parallax on scroll ---------- */
  function initParallax() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var els = document.querySelectorAll('[data-parallax]');
    if (!els.length) return;
    var tick = function () {
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        var speed = parseFloat(el.getAttribute('data-parallax')) || 0.1;
        var offset = (r.top + r.height / 2 - vh / 2) * -speed;
        el.style.transform = 'translateY(' + offset + 'px)';
      });
    };
    window.addEventListener('scroll', tick, { passive: true });
    tick();
  }

  /* ---------- Count-up stats ---------- */
  function initCountUp() {
    var nums = document.querySelectorAll('[data-count]');
    if (!nums.length || !('IntersectionObserver' in window)) {
      nums.forEach(function (n) { n.textContent = n.getAttribute('data-count'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target, target = parseFloat(el.getAttribute('data-count')), suffix = el.getAttribute('data-suffix') || '';
        var start = 0, dur = 1400, t0 = null;
        var step = function (ts) {
          if (!t0) t0 = ts;
          var p = Math.min((ts - t0) / dur, 1);
          var val = Math.floor((0.5 - Math.cos(p * Math.PI) / 2) * target);
          el.textContent = val.toLocaleString() + suffix;
          if (p < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
        io.unobserve(el);
      });
    }, { threshold: 0.4 });
    nums.forEach(function (n) { io.observe(n); });
  }

  /* ---------- Stagger groups ---------- */
  function initStagger() {
    var groups = document.querySelectorAll('.stagger');
    if (!('IntersectionObserver' in window)) { groups.forEach(function (g) { g.classList.add('is-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { threshold: 0.15 });
    groups.forEach(function (g) { io.observe(g); });
  }

  /* ---------- Scroll progress bar ---------- */
  function initScrollProgress() {
    var bar = document.querySelector('[data-scroll-progress]');
    if (!bar) return;
    var onScroll = function () {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.width = (h > 0 ? (window.scrollY / h * 100) : 0) + '%';
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initAnnouncement();
    markWishlist();
    initHeroTilt();
    initHeaderScroll();
    initTilt();
    initMagnetic();
    initParallax();
    initCountUp();
    initStagger();
    initScrollProgress();
  });
})();
